export const PAGE_TYPE = {
  LISTING_PAGE: 'listingPage',
  STUB_PAGE: 'stubPage',
  LANDING_PAGE: 'landingPage',
};

export const PAGE_SUB_TYPE = {
  ORGANISATION: 'organisation',
  PROFILE: 'profile',
  NEW_AND_RARE: 'newAndRare',
  PRODUCTION: 'production',
  SEASON: 'season',
  WORK: 'work',
  STATISTICS: 'statistics',
  HIGHLIGHT: 'highlight',
  MANAGER: 'manager',
  COMPETITION: 'competition',
  RENTAL: 'rental',
  VENUES: 'venues',
  VIDEO: 'video',
  PRO_COMPANY: 'proCompany',
  PRO_AGENCY: 'proAgency',
  PRO_ARTIST: 'proArtist',
  HOME: 'home',
  CASTING_TOOL: 'castingTool',
};

export const PAGE_ENTITY_TYPE = {
  FESTIVAL: 'festival',
  PRODUCTION: 'production',
  PROFILE: 'profile',
  COMPANY: 'company',
  COMPETITION: 'competition',
  MANAGER: 'manager',
  RENTAL: 'rental',
  VENUES: 'venues',
  WORK: 'work',
};

export const FOOTPRINT_TRACKING_ENDPOINT = 'fingerprints';
